module.exports = __webpack_public_path__ + "static/bottom-0bfd98b5d477499891627fceb112bcd2.png";